import PaymentSuccessComponent from '../Components/PaymentSucess/index';

const PaymentSuccess =()=>{
    return (
        <PaymentSuccessComponent/>
    )
}

export default PaymentSuccess;